import { render } from "./DetailPage.vue?vue&type=template&id=7317a110&scoped=true"
import script from "./DetailPage.vue?vue&type=script&lang=js"
export * from "./DetailPage.vue?vue&type=script&lang=js"

import "./DetailPage.vue?vue&type=style&index=0&id=7317a110&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7317a110"]])

export default __exports__